import { useEffect, useState } from "react"
import { useSiteContent } from "@/shared/content/SiteContentProvider"
import { cn } from "@/shared/lib/cn"
import { handleAnchorClick } from "@/shared/lib/navigation"
import { openWhatsApp } from "@/shared/lib/whatsapp"
import { Logo, LogoSymbol } from "@/shared/layout/Logo"
import { Button } from "@/shared/ui/Button"
import { ArrowRight, ArrowRightSm, Close, Menu } from "@/shared/ui/icons"

const CLIENT_AREA_HREF = "#area-cliente"

export function Header() {
  const { navigation } = useSiteContent()
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16)
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return (
    <>
      <header
        className={cn(
          "fixed top-0 left-0 right-0 z-40 transition-all duration-300",
          scrolled ? "bg-off-white/95 backdrop-blur-md shadow-sm border-b border-verde-profundo/8" : "bg-off-white",
        )}
      >
        <div className="max-w-[1280px] mx-auto px-6 h-[72px] flex items-center justify-between gap-6">
          <a
            href="#inicio"
            onClick={(event) => handleAnchorClick(event, "#inicio")}
            className="shrink-0"
            aria-label="Ir para o início"
          >
            <Logo />
          </a>

          <nav className="hidden lg:flex items-center gap-1" aria-label="Navegação principal">
            {navigation.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(event) => handleAnchorClick(event, link.href)}
                className="px-3 py-2 text-sm font-medium text-verde-profundo/75 hover:text-verde-profundo rounded-lg hover:bg-verde-profundo/5 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3 shrink-0">
            <a
              href={CLIENT_AREA_HREF}
              onClick={(event) => handleAnchorClick(event, CLIENT_AREA_HREF)}
              className="text-sm font-medium text-verde-profundo/70 hover:text-verde-profundo transition-colors"
            >
              Área do cliente
            </a>
            <Button variant="primary" size="sm" onClick={() => openWhatsApp()} icon={<ArrowRightSm />}>
              Contratar agora
            </Button>
          </div>

          <button
            type="button"
            className="lg:hidden w-10 h-10 flex items-center justify-center text-verde-profundo rounded-lg hover:bg-verde-profundo/8 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(true)}
            aria-label="Abrir menu"
            aria-expanded={mobileOpen}
          >
            <Menu />
          </button>
        </div>
      </header>

      {mobileOpen && (
        <div className="fixed inset-0 z-50 flex">
          <div
            className="absolute inset-0 bg-verde-profundo/40 backdrop-blur-sm"
            onClick={() => setMobileOpen(false)}
            aria-hidden="true"
          />

          <div className="relative ml-auto w-[80vw] max-w-sm bg-off-white h-full flex flex-col shadow-2xl">
            <div className="flex items-center justify-between p-5 border-b border-verde-profundo/10">
              <LogoSymbol />
              <button
                type="button"
                onClick={() => setMobileOpen(false)}
                aria-label="Fechar menu"
                className="w-9 h-9 flex items-center justify-center text-verde-profundo rounded-lg hover:bg-verde-profundo/8 cursor-pointer"
              >
                <Close />
              </button>
            </div>

            <nav className="flex flex-col p-4 gap-1 flex-1 overflow-y-auto" aria-label="Navegação mobile">
              {navigation.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(event) => handleAnchorClick(event, link.href, () => setMobileOpen(false))}
                  className="px-4 py-3 text-base font-medium text-verde-profundo hover:bg-verde-profundo/8 rounded-xl transition-colors"
                >
                  {link.label}
                </a>
              ))}

              <div className="h-px bg-verde-profundo/10 my-2" />

              <a
                href={CLIENT_AREA_HREF}
                onClick={(event) => handleAnchorClick(event, CLIENT_AREA_HREF, () => setMobileOpen(false))}
                className="px-4 py-3 text-base font-medium text-verde-profundo/70 hover:bg-verde-profundo/8 rounded-xl transition-colors"
              >
                Área do cliente
              </a>
            </nav>

            <div className="p-4 border-t border-verde-profundo/10">
              <Button
                variant="primary"
                size="lg"
                className="w-full"
                onClick={() => {
                  setMobileOpen(false)
                  openWhatsApp()
                }}
                icon={<ArrowRight />}
              >
                Contratar agora
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Barra fixa de conversao no mobile. */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-white/95 backdrop-blur-md border-t border-verde-profundo/10 shadow-lg">
        <Button
          variant="primary"
          size="md"
          className="w-full"
          onClick={() => openWhatsApp()}
          icon={<ArrowRight />}
        >
          Contratar agora
        </Button>
      </div>
    </>
  )
}
